export default "__VITE_ASSET__DSMW31SX__"